module.exports = __webpack_public_path__ + "static/media/redfbBg2.aa1ce5ca.webp";